import React from "react";
var __jsx = React.createElement;
import { Then } from "@componentsShared/Conditional/Then";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { Else } from "@componentsShared/Conditional/Else";
import CashOptionTwo from "@/pages/checkout/pre-checkout/variants/CashOptionTwo";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import FinanceOptionTwo from "@/pages/checkout/pre-checkout/variants/FinanceOptionTwo";
import BuyNowPayLater from "@/pages/checkout/pre-checkout/PurchaseMethods/BuyNowPayLater";
var VariantTwo = function VariantTwo() {
  var checkoutOrder = useCheckoutOrder().state.checkoutOrder;
  var have_finance = checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.have_finance;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 pb-2"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: have_finance
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:pb-4"
  }, /*#__PURE__*/React.createElement(FinanceOptionTwo, {
    disabled: !have_finance
  }), /*#__PURE__*/React.createElement(CashOptionTwo, null)), /*#__PURE__*/React.createElement(BuyNowPayLater, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(CashOptionTwo, null), /*#__PURE__*/React.createElement(BuyNowPayLater, null), /*#__PURE__*/React.createElement(FinanceOptionTwo, {
    disabled: !have_finance
  })))));
};
export default VariantTwo;